

const checkNode = () => {
  return fetch("/api/checknode", {
    method: "GET",
    // headers: headers(),
  })
  .then((response) => response.json())
  .then((data) => {
    // console.log(data)
    return data
  })
  .catch((error) => console.log(error));
}



export {
  checkNode
}
